import { Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import ScrollRestorationHandler from "~/components/ScrollRestorationHandler";
import FeatureAccess from "~/components/common/FeatureAccess";
import ModuleAccess from "~/components/common/ModuleAccess";
import { Loading } from "~/components/general";
import { ScrollRestorationProvider } from "~/contexts/ScrollRestorationContext";

export default ({ intl, routes = [], DefaultRoute, user, appConfig }) => (
  <Routes>
    {routes.map((route) => {
      const relativePath = route.path.replace("/app/", "");
      // In v6, all routes are exact by default. Append /* for non-exact routes.
      const path =
        route.exact === false || !("exact" in route)
          ? `${relativePath}/*`
          : relativePath;
      if (typeof route.Main !== "function" && !route.Main?.$$typeof) {
        console.error(
          "[Routes] Invalid Main for route:",
          route.path,
          route.Main,
        );
      }
      return (
        <Route
          key={route.key || route.path}
          path={path}
          element={
            <FeatureAccess>
              <Main>
                <ModuleAccess>
                  <route.Main
                    intl={intl}
                    user={user}
                    appFeatures={appConfig?.features}
                    appConfig={appConfig}
                  />
                </ModuleAccess>
              </Main>
            </FeatureAccess>
          }
        />
      );
    })}
    {/* default route if no path matches */}
    <Route path="*" element={<Navigate to={DefaultRoute.path} replace />} />
  </Routes>
);

export const Main = ({ children }) => {
  const location = useLocation();

  return (
    <ScrollRestorationProvider>
      <main
        className={`w-full h-screen overflow-y-auto ${
          location.pathname === "/app/work/scheduler" ? "no-scrollbar" : ""
        }`}
      >
        <ScrollRestorationHandler />
        <Suspense fallback={<Loading />}>{children}</Suspense>
      </main>
    </ScrollRestorationProvider>
  );
};
